import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  @Input() success: boolean = false;
  @Input() failure: boolean = false;
  @Input() warning: boolean = false;
  @Input() manualCloser: boolean = false;
  @Output() close: EventEmitter<any> = new EventEmitter();
  fadeOutTrigger = false;



  ngOnInit(): void {
    if (this.success || this.warning) {
      setTimeout(() => {
        this.fadeOutTrigger = true;
        const toastElement = document.querySelector('.text-center');
        if (toastElement) {
          toastElement.classList.add('fade-out');
          setTimeout(() => {
            this.close.emit(true);
          }, 2000);
        }
      }, 4000);
    }
    this.success;
    this.failure;
    this.manualCloser;
  }

  closeToast() {
    this.fadeOutTrigger = true;
    const toastElement = document.querySelector('.text-center');
    if (toastElement) {
      toastElement.classList.add('fade-out');
      setTimeout(() => {
        this.close.emit(true);
      }, 5000);
    }

  }
}
